module.exports = __webpack_public_path__ + "img/icon rojo.f3e9214e.png";